import { all, fork } from "redux-saga/effects";
import { modules } from "veritone-redux-common";
import routeSaga from "modules/routing/sagas";
import appSaga from "modules/app/sagas";
import folderSaga from "../modules/app/folderSagas";
import advertiserSaga from "../modules/app/advertiserSaga";
import campaignSaga from "../modules/app/campaignSaga";
import campaignSagaNew from '../modules/app/campaign/saga';
import appSettingSaga from "../modules/app/appSettingSaga";
import { mentionSaga } from "modules/app/mentions";
import visualDataRefreshSaga from "modules/app/visualDataRefreshSaga";
import filePickerRootSaga from "modules/filePicker/filePickerSaga";
import geoSelectorSaga from '../modules/app/geoSelector/saga';
import userManagementSaga from '../modules/app/userManagement/saga';
import orgManagementSaga from '../modules/app/orgManagement/saga';
import {searchSagas} from 'modules/app/search';
import { logoutSaga } from '../modules/auth/saga';
import marketSaga from 'modules/app/market/saga';
import timeZoneSaga from '../modules/app/timeZone/saga'
import creativeMappingSaga from '../modules/app/creativeMapping/saga';
import playoutSaga from '../modules/app/playout/saga';
import stationSaga from '../modules/app/station/saga';
import scheduleReportSaga from '../modules/app/scheduleReport/saga';
import campaignErrorSaga from '../modules/app/campaignErrorSaga';
import emailTemplateSaga from '../modules/app/emailTemplateSaga';

const {
  auth: { authRootSaga }
} = modules;
// these are sagas that should run on *all* routes, at app startup.
// define route-specific sagas on the routesMap
export default function* sagas() {
  yield all([
    fork(routeSaga),
    fork(appSaga),
    fork(authRootSaga),
    fork(folderSaga),
    fork(advertiserSaga),
    fork(mentionSaga),
    fork(appSettingSaga),
    fork(filePickerRootSaga),
    fork(campaignSaga),
    fork(campaignSagaNew),
    fork(visualDataRefreshSaga),
    fork(geoSelectorSaga),
    fork(userManagementSaga),
    fork(orgManagementSaga),
    fork(searchSagas),
    fork(logoutSaga),
    fork(marketSaga),
    fork(timeZoneSaga),
    fork(creativeMappingSaga),
    fork(playoutSaga),
    fork(stationSaga),
    fork(scheduleReportSaga),
    fork(campaignErrorSaga),
    fork(emailTemplateSaga),
  ]);
}
